// classify :: String -> Element -> Element
//          :: [String] -> Element -> Element
export const classify = classNames => element => {
  element.classList.add(...[].concat(classNames));
  return element;
};
